import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "kroma_cookie_consent_v1";

/** Consentimento guardado: { essential: true, analytics: bool, at } */
export function getCookieConsent() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

export default function CookieBanner() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) setVisible(true);
  }, []);

  if (!visible || pathname.startsWith("/admin")) return null;

  const decide = (analytics) => {
    localStorage.setItem(KEY, JSON.stringify({ essential: true, analytics, at: new Date().toISOString() }));
    setVisible(false);
    window.dispatchEvent(new CustomEvent("kroma:consent", { detail: { analytics } }));
  };

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] border border-[#222225] bg-[#0C0C0E] text-white shadow-2xl p-5"
      role="dialog"
      aria-label="Consentimento de cookies"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-[#FF3B00] shrink-0 mt-0.5" />
        <div className="text-sm">
          <div className="font-medium mb-1">Cookies e privacidade</div>
          <p className="text-[#8B8B93] leading-relaxed">
            Usamos apenas o armazenamento essencial para o carrinho, a sessão e o pagamento seguro. Estatísticas anónimas só com a sua autorização.{" "}
            <Link to="/legal/cookies" className="text-[#FF3B00] hover:underline">Saber mais</Link>
          </p>
        </div>
      </div>
      <div className="flex gap-2 mt-4">
        <button
          type="button"
          onClick={() => decide(false)}
          data-testid="cookie-essential-btn"
          className="flex-1 border border-[#3F3F46] hover:border-white px-3 py-2 text-sm transition-colors"
        >
          Só essenciais
        </button>
        <button
          type="button"
          onClick={() => decide(true)}
          data-testid="cookie-accept-btn"
          className="flex-1 bg-[#FF3B00] hover:bg-[#FF5722] text-white px-3 py-2 text-sm font-medium transition-colors"
        >
          Aceitar todos
        </button>
      </div>
    </div>
  );
}
